<template>
  <div class="head"
       @mouseenter="isMenuShow=true"
       @mouseleave="isMenuShow=false">
    <div class="flex-left"
         style="width:100%">
      <div class="logo"></div>
      <!-- <div class="menu" :class=" isMenuShow?'hide':'show'"></div> -->
      <div class="menu  flex-right "
           :class=" isMenuShow?'show':'hide'">
        <div class="menu-list flex-left"
             :class="isMenuShow?'':'menuhide'">
          <div class="menu-item "
               v-for="(item,index) in menuList"
               :key="index">
            <router-link :to='item.routerUrl'>

              <div class="item"
                   style="font-size: 16px;"
                   :class="$route.path==item.routerUrl?'active':'text-desc'">
                {{item.name}}
              </div>
            </router-link>
          </div>

        </div>
      </div>
      <div class="show-menu"
           @click="showMenu">
        <img src="https://website.didiglobal.com/dist/media/menu1.423191ca.svg"
             style="    width: 26px;    height: 14px;"
             alt="">
      </div>
    </div>
  </div>
</template>

<script>
import info from '../util/info'

export default {

  data () {
    return {
      menuList: info.menuList,
      isMenuShow: false
    }
  },

  methods: {

    showMenu () { this.isMenuShow = !this.isMenuShow }
  }
}
</script>

<style scoped>
.menuhide {
  display: none;
}
.show {
  /* animation: 1s rotateIn; */
}
.hide {
  /* animation: 2s fadeOutRight; */
}
.show-menu {
  text-align: center;
  cursor: pointer;
  width: 145px;
  height: 48px;
  line-height: 48px;
  margin-right: 60px;
}
.menu {
  text-align: right;
  width: calc(100% - 275px);
  min-width: 740px;
  overflow: hidden;
}
.logo {
  margin-left: 60px;
  width: 230px;
  height: 48px;
  line-height: 48px;
  background-image: url("../assets/logo.png");
  background-repeat: no-repeat;
}
.head {
  height: 88px;
  line-height: 88px;
  margin: 0 auto;
  width: 100%;
  position: fixed;
  z-index: 99;
  display: flex;
  align-content: center;
  align-items: center;
}
.head:hover {
  background: rgba(0, 0, 0, 0.4);
}
.menu-item {
  width: 145px;
}
.menu-list {
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/webheader.vue